import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {CustomerPreview} from './components/CustomerPreview';
import {SupportPreview} from './components/SupportPreview';
import {VehicleInvitation} from './components/VehicleInvitation';
import {ShopPayment} from './components/ShopPayment';
import {ShopLocale} from './lib/shopI18n';
import {paymentReturnToken,clearPaymentReturn} from './lib/shopPayments';
import {SHOP_API} from './components/PreparationShop';
import {PreparationExperience,PrecisionShop} from './components/PreparationShop';
import {GuestService} from './components/GuestService';
import './styles.css';
import './enhancements.css';
import './photo-stage.css';
import './tesla.css';
import './integrated-tools.css';
import './maintenance-v2.css';
import './welcome.css';
import './ev-comparator.css';
import './account-entry.css';
import './theme.css';
import './vehicle-inventory.css';
import { loadSettings } from './lib/storage';
import { DeveloperGate } from './components/DeveloperGate';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { WorkshopMobileApp } from './components/WorkshopMobileApp';
import './workshop-mobile.css';
import './app-viewport.css';
import './theme-fixes.css';
import {installAppViewport} from './lib/appViewport';
import {installPortugueseValidation} from './lib/portugueseValidation';
const removeViewportGuards=installAppViewport();
if(import.meta.hot)import.meta.hot.dispose(removeViewportGuards);
const removePortugueseValidation=installPortugueseValidation();
if(import.meta.hot)import.meta.hot.dispose(removePortugueseValidation);

document.documentElement.dataset.theme = loadSettings().theme;

const customerPreviewMode=new URLSearchParams(location.hash.slice(1)).get('staff-preview')==='1';
const supportPreviewMode=new URLSearchParams(location.hash.slice(1)).get('support-preview')==='1';
const invitationKey=new URLSearchParams(location.hash.slice(1)).get('car-key');
const workshopMode = new URLSearchParams(location.search).get('workshop') === '1' || /^\/workshop\/?$/.test(location.pathname);

import {UnifiedShop} from './components/UnifiedShop';
const publicShop=/^\/shop(?:\/(?:workshops|used))?\/?$/.test(location.pathname);
const storeQuery=new URLSearchParams(location.search).get('store');
const publicStore=storeQuery==='workshops'||location.pathname.includes('/workshops')?'workshops':storeQuery==='used'||location.pathname.includes('/used')?'used':'retail';
const preparationToken=new URLSearchParams(location.search).get('tvpf');
const preparationMode=!!preparationToken&&!new URLSearchParams(location.search).has('claim');
const guestToken=new URLSearchParams(location.search).get('dossier');
const guestMode=!!guestToken&&!new URLSearchParams(location.search).has('claim');
const returnId=new URLSearchParams(location.search).get('paymentReturn')||'';
const returnToken=/^PS-[A-F0-9]{10}$/.test(returnId)?paymentReturnToken(returnId):undefined;
const leaveGuestPayment=()=>{clearPaymentReturn(returnId);location.replace('/?tvpf='+encodeURIComponent(returnToken!));};
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><AppErrorBoundary><DeveloperGate>{supportPreviewMode ? <SupportPreview/> : customerPreviewMode ? <CustomerPreview/> : invitationKey ? <VehicleInvitation invitationKey={invitationKey}/> : returnToken ? <ShopLocale language={loadSettings().language}><ShopPayment apiBase={SHOP_API} orderId={returnId} token={returnToken} onBack={leaveGuestPayment} onPaid={leaveGuestPayment}/></ShopLocale> : publicShop ? <UnifiedShop store={publicStore} language={loadSettings().language} theme={loadSettings().theme} onClose={()=>location.assign('/')}/> : preparationMode ? <PreparationExperience token={preparationToken!}/> : guestMode ? <GuestService token={guestToken!}/> : workshopMode ? <WorkshopMobileApp/> : <App/>}</DeveloperGate></AppErrorBoundary></React.StrictMode>);

const embeddedInDrive=location.pathname.includes('/demo/precision-ev/');
if('serviceWorker' in navigator && import.meta.env.PROD && !embeddedInDrive) window.addEventListener('load',()=>navigator.serviceWorker.register('/sw.js',{updateViaCache:'none'}).then((registration)=>registration.update()).catch(()=>undefined));
